function s(n) {
  return n != null && typeof n.valueOf() == "string";
}
function e(n) {
  return n != null && typeof n.valueOf() == "number";
}
function t(n) {
  return n != null && typeof n.valueOf() == "boolean";
}
const a = (n) => f(n) || b(n), q = (n) => n.type === "functioncall" && Object.prototype.hasOwnProperty.call(n, "name") && s(n.name) && Object.prototype.hasOwnProperty.call(n, "args") && Array.isArray(n.args) && n.args.every((r) => a(r)), b = (n) => s(n) || e(n) || t(n) || n === null, d = (n) => !!((n != null && n.min || n != null && n.max) && (!n.min || u(n.min) || e(n.min)) && (!n.max || u(n.max) || e(n.max))), E = (n) => m(n) || y(n) || p(n), m = (n) => ["==", "*=", "!=", "<", "<=", ">", ">=", "<=x<="].includes(n), y = (n) => ["&&", "||"].includes(n), p = (n) => n === "!", c = (n) => S(n) || h(n) || l(n) || x(n) || l(n) || t(n), S = (n) => {
  const r = n && n[0] === "<=x<=" ? 4 : 3;
  return Array.isArray(n) && n.length === r && m(n[0]) && a(n[1]) && a(n[2]) && (n[0] !== "<=x<=" || e(n[3]));
}, h = (n) => Array.isArray(n) && n.length >= 3 && y(n[0]) && n.every((r, i) => i === 0 || c(r)), x = (n) => Array.isArray(n) && n.length === 2 && p(n[0]) && c(n[1]), C = (n) => O(n) || F(n) || v(n) || z(n), O = (n) => T(n) || N(n) || A(n), T = (n) => (n == null ? void 0 : n.kind) === "Icon", A = (n) => (n == null ? void 0 : n.kind) === "Text", N = (n) => (n == null ? void 0 : n.kind) === "Mark" && s(n == null ? void 0 : n.wellKnownName), F = (n) => (n == null ? void 0 : n.kind) === "Line", v = (n) => (n == null ? void 0 : n.kind) === "Fill", z = (n) => (n == null ? void 0 : n.kind) === "Raster", G = (n) => {
  var r;
  return !!(s(n == null ? void 0 : n.name) && (!(n != null && n.filter) || c(n.filter)) && (!(n != null && n.scaleDenominator) || d(n.scaleDenominator)) && ((r = n == null ? void 0 : n.symbolizers) != null && r.every((i) => C(i))));
}, I = (n) => (n == null ? void 0 : n.redChannel) !== void 0 || (n == null ? void 0 : n.greenChannel) !== void 0 || (n == null ? void 0 : n.blueChannel) !== void 0, L = (n) => (n == null ? void 0 : n.grayChannel) !== void 0, u = (n) => [
  "abs",
  "acos",
  "add",
  "asin",
  "atan",
  "atan2",
  "ceil",
  "cos",
  "div",
  "exp",
  "floor",
  "interpolate",
  "log",
  "max",
  "min",
  "modulo",
  "mul",
  "pi",
  "pow",
  "random",
  "rint",
  "round",
  "sin",
  "sqrt",
  "strIndexOf",
  "strLastIndexOf",
  "strLength",
  "sub",
  "tan",
  "toDegrees",
  "toNumber",
  "toRadians"
].includes(n == null ? void 0 : n.name), k = (n) => [
  "numberFormat",
  "strAbbreviate",
  "strCapitalize",
  "strConcat",
  "strDefaultIfBlank",
  "strReplace",
  "strStripAccents",
  "strSubstring",
  "strSubstringStart",
  "strToLowerCase",
  "strToString",
  "strToUpperCase",
  "strTrim"
].includes(n == null ? void 0 : n.name), l = (n) => [
  "all",
  "any",
  "between",
  "double2bool",
  "equalTo",
  "greaterThan",
  "greaterThanOrEqualTo",
  "in",
  "lessThan",
  "lessThanOrEqualTo",
  "not",
  "notEqualTo",
  "parseBoolean",
  "strEndsWith",
  "strEqualsIgnoreCase",
  "strMatches",
  "strStartsWith"
].includes(n == null ? void 0 : n.name), w = (n) => [
  "case",
  "property",
  "step"
].includes(n == null ? void 0 : n.name), f = (n) => l(n) || u(n) || k(n) || w(n), R = (n) => typeof (n == null ? void 0 : n.source) == "string" || f(n == null ? void 0 : n.source) && Array.isArray(n.position) && Array.isArray(n.size);
export {
  h as isCombinationFilter,
  y as isCombinationOperator,
  S as isComparisonFilter,
  m as isComparisonOperator,
  a as isExpression,
  v as isFillSymbolizer,
  c as isFilter,
  q as isFunctionCall,
  l as isGeoStylerBooleanFunction,
  f as isGeoStylerFunction,
  u as isGeoStylerNumberFunction,
  k as isGeoStylerStringFunction,
  w as isGeoStylerUnknownFunction,
  L as isGrayChannel,
  T as isIconSymbolizer,
  F as isLineSymbolizer,
  N as isMarkSymbolizer,
  x as isNegationFilter,
  p as isNegationOperator,
  E as isOperator,
  O as isPointSymbolizer,
  b as isPropertyType,
  z as isRasterSymbolizer,
  I as isRgbChannel,
  G as isRule,
  d as isScaleDenominator,
  R as isSprite,
  C as isSymbolizer,
  A as isTextSymbolizer
};
